import { Component, Input, OnInit } from '@angular/core';
import { ICardDetailBody } from '@models/card.model';
import { BehaviorSubject } from 'rxjs';
import { BaseComponent } from '@shared/base/base.component';

@Component({
  selector: 'app-card-document',
  templateUrl: './card-document.component.html',
  styleUrls: ['./card-document.component.scss'],
})
export class CardDocumentComponent extends BaseComponent implements OnInit {
  @Input() title: string;
  @Input() cardClass: string;
  @Input() bodyList: ICardDetailBody[];
  @Input() loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  @Input() titleInBody = false;

  constructor() {
    super();
  }

  ngOnInit(): void {}
}
